import { Skeleton } from "@/components/ui/skeleton";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

export function AppSidebarOverlineItem({
  item,
  index,
  isAfterDivider = false,
}: {
  item: { type: string; name: string; isLoading?: boolean };
  index: number;
  /**
   * Straight under a divider, which already spaces the groups apart: the
   * heading sits just below its rule rather than at the foot of a row of its
   * own, and the minimized sidebar shows the divider's rule alone.
   */
  isAfterDivider?: boolean;
}) {
  return (
    <div
      key={item.type + index}
      className={cn(
        "pl-4 pr-4 pb-0.5",
        isAfterDivider ? "h-auto" : "h-8",
        "w-full flex items-center justify-center [@container_(min-width:_51px)]:justify-start [@container_(min-width:_51px)]:items-end",
        isAfterDivider && "[@container_(max-width:_50px)]:hidden",
        "z-1",
      )}
    >
      <div
        key={item.type + index}
        className="w-full h-px bg-border [@container_(min-width:_51px)]:hidden"
      />
      <Typography className="text-xs font-medium text-muted-foreground [@container_(max-width:_50px)]:hidden">
        <Skeleton loading={item.isLoading ?? false} variant="inline">
          {item.name}
        </Skeleton>
      </Typography>
    </div>
  );
}
